import { oz } from '@weft/utils';
import { NewPaymentSchema } from './new-payment-schema';

export const PaymentInputSchema = oz.object(NewPaymentSchema.shape).partial().openapi('PaymentInput');

export type PaymentInput = oz.infer<typeof PaymentInputSchema>;
